module.exports = __webpack_public_path__ + "assets/img/noVipBg.bc93406b.png";